import { TemplatedString } from '@payflip/types/product-builder';
import { FunctionalHOC } from '../renderer';

export const withTemplatedString: FunctionalHOC = (Component) => {
  return (props) => {
    const templatedStrings = checkAndResolve({ ...props }, {} as typeof props);

    const mergedProps = {
      ...props,
      ...templatedStrings
    };

    return <Component {...mergedProps} />;
  };
};

function checkAndResolve<T extends { [K in keyof T]: T[K] }>(
  obj: T,
  seed: T
): T {
  const formattedDates = Object.entries(obj).reduce((acc, [key, value]) => {
    if (isTemplatedString(value)) {
      return { ...acc, [key]: resolve(value) };
    }

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const nestedResult = checkAndResolve({ ...value }, {});
      return { ...acc, [key]: { ...nestedResult } };
    }

    return { ...acc, [key]: value };
  }, seed);

  return formattedDates;
}

export function resolve(props: TemplatedString): string {
  const text = Object.entries(props.values ?? {}).reduce(
    (acc, [key, value]) => {
      const expr = new RegExp(`{${key}}`, 'g');
      return acc.replace(expr, `${value}`);
    },
    props.template
  );

  return text;
}

function isTemplatedString(
  prop: TemplatedString | unknown
): prop is TemplatedString {
  return (
    typeof prop === 'object' &&
    prop !== null &&
    Object.keys(prop).length === 2 &&
    'template' in prop &&
    'values' in prop
  );
}
